var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavingsIconTwo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "#EEF2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 27L28 37V41H66V37M56 45V59H62V45M28 69H66V63H28M44 45V59H50V45M32 45V59H38V45H32Z",
    fill: "#B8C8CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsIconTwo);
export default __webpack_public_path__ + "static/media/savings-icon-two.0079dedcda67e89e2cc5006adc4ead33.svg";
export { ForwardRef as ReactComponent };